import type { StateService } from "@uirouter/angularjs";
import type { IScope, IWindowService } from "angular";

import type { IEquipmentFunctionalityType, IResponseWithLoading } from "App/Modules/Models";
import { FpsFunctions, ResolutionMode } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export default class VideoPropertiesComponentController {
    public static $inject: string[] = ["$scope", "$state", "$window", "mmModalService"];

    public equipmentFunctionalityType: IResponseWithLoading<IEquipmentFunctionalityType>;

    public resolutionModes: string;

    public resolutions: string;

    public fps: string;

    constructor(
        private readonly $scope: IScope,
        private readonly stateService: StateService,
        private readonly $window: IWindowService,
        private readonly modalService: IModalService,
    ) {}

    public $onChanges() {
        this.updateData();
    }

    public editVideoProperties() {
        this.modalService
            .open<IEquipmentFunctionalityType, void>(
                "irEditFunctionalityVideoProperties",
                this.equipmentFunctionalityType.data,
            )
            .subscribe(
                (editResponse) => {
                    if (editResponse) {
                        this.equipmentFunctionalityType.data = editResponse;
                        this.updateData();
                    }
                },
                (reason) => reason,
            );
    }

    private updateData() {
        if (this.equipmentFunctionalityType.data) {
            this.resolutions = this.equipmentFunctionalityType.data.supportedResolutions.join(", ");
            this.resolutionModes = this.equipmentFunctionalityType.data.supportedResolutionModes
                .map((res: ResolutionMode) => ResolutionMode[res])
                .sort()
                .join(", ");
            this.fps = this.equipmentFunctionalityType.data.supportedFpses
                .map((f) => FpsFunctions.GetFpsString(f))
                .join(", ");
            this.$scope.$applyAsync();
        }
    }
}
